module.exports = __webpack_public_path__ + "img/CWO.7a4eeb62.jpg";